
import { redirectRoute } from '../../../src/routes/helpers';
import AppActions from '../../../src/actions/AppActions';
import { DelayRepayPages } from '../../../src/constants/AppConstants';
import DelayRepayApp from '../components/App';

const delayRepayRoute = {
    component: DelayRepayApp,
    path: '/',

    // Redirect / to /customer-details
    indexRoute: redirectRoute(null, DelayRepayPages.CUSTOMER),

    onEnter (nextState) {
        const { location } = nextState;
        if (location.query) {
            const featureFlags = Object.keys(location.query)
                .filter((param) => param.startsWith('feature.'));
            featureFlags.forEach((param) => {
                const feature = param.replace('feature.', '');
                const featureValue = location.query[param];
                AppActions.toggleFeature(feature, !!featureValue.match(/^(?:yes|true|on|1)$/i));
            });
        }
    },

    childRoutes: [
        require('./Compensation/Details').default,
        require('./Compensation/Season').default,
        require('./Compensation/NonSeason').default,
        require('./Compensation/Whitelist').default,
        require('./DelayRepay/CustomerDetails').default,
        require('./DelayRepay/Claims').default,
        require('./DelayRepay/Refund').default,
        require('./DelayRepay/Confirm').default,
        require('./Account/AutoDelayRepay').default,
        require('./AutoDelayRepay/Subscription').default,
        redirectRoute('/**', DelayRepayPages.CUSTOMER)
    ].filter((x) => !!x) //Remove any null routes
};

export default delayRepayRoute;
